import { useNormalizedMarketsStore } from '../normalizedMarkets.store';

export const useIsLoading = () => useNormalizedMarketsStore((state) => state.isDiscoveryLoading);

export const useError = () => useNormalizedMarketsStore((state) => state.discoveryError);

export const useParams = () => useNormalizedMarketsStore((state) => state.discoveryParams);

export const useSubCategoriesLoading = () =>
  useNormalizedMarketsStore(
    (state) => state.isSubCategoriesLoading && state.subCategories.length === 0
  );

export const useAreSubCategoriesResolved = () =>
  useNormalizedMarketsStore(
    (state) => state.subCategories.length > 0 || !!state.subCategoriesError
  );
